// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1269":"45367554","5360":"45367554","7001":"45367554"}[chunkId] + ".chunk.css";
};